import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  getShowSubscribeWindow,
  setShowSubscribeWindow,
} from "features/states/statesSlice";
import { IconClose } from "assets/assetReference";
import { ContactSubscribe } from "components/Contact/Contact";

export default function SubscribeButton() {
  const showSubscribeWindow = useSelector(getShowSubscribeWindow);
  const dispatch = useDispatch();
  return (
    <div className="fixed bottom-0 left-0 z-[999999999]">
      {showSubscribeWindow ? (
        <div className="bg-white border h-full m-6 p-6 max-h-[calc(100vh-3rem)] rounded-md shadow-lg overflow-y-scroll ">
          <IconClose
            onClick={() => {
              dispatch(setShowSubscribeWindow(false));
            }}
            className="hover:cursor-pointer ml-auto"
          />
          <p className="text-2xl font-headings font-bold">
            Subscribe to Our Newsletter
          </p>
          <ContactSubscribe />
        </div>
      ) : (
        <div className="m-6">
          <button
            type="button"
            onClick={() => {
              dispatch(setShowSubscribeWindow(true));
            }}
            className="bg-main shadow-md px-4 py-1 text-white hover:bg-main-darker"
          >
            Subscribe
          </button>
        </div>
      )}
    </div>
  );
}
